import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import { VectorMap } from '@react-jvectormap/core'
import { worldMill } from '@react-jvectormap/world'
import { inMill } from '@react-jvectormap/india'
import { usMill } from '@react-jvectormap/unitedstates'
import { ukCountriesMill } from '@react-jvectormap/unitedkingdomcountries'
import { auMill } from '@react-jvectormap/australia'

export default function JvectorMap() {

    return (
        <>
            <Breadcrumb title="Jvector Map" path="Charts / Jvector Map" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15 mb-30'>
                <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
                    World Map
                </p>
                <div className='sm:h-[300px] h-[150px]'>
                    <VectorMap
                        map={worldMill}
                        backgroundColor='var(--bg-dark)'
                        regionStyle={{
                            initial: {
                                fill: "var(--text-secondary)"
                            },
                            hover: {
                                fill: "var(--primary)"
                            },
                        }}
                        series={{
                            regions: [{
                                attribute: 'fill',
                                values: {
                                    'IN': 'var(--danger)',
                                    'AU': 'var(--success)',
                                    'US': 'var(--sky)',
                                    'GB': 'var(--warning)',
                                    'SA': 'var(--info)',
                                }
                            }]
                        }}
                    />
                </div>
            </div>
            <div className='grid md:grid-cols-2 gap-30 mb-30'>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
                        India Map
                    </p>
                    <div className='sm:h-[300px] h-[150px]'>
                        <VectorMap
                            map={inMill}
                            backgroundColor='var(--bg-dark)'
                            regionStyle={{
                                initial: {
                                    fill: "var(--danger)"
                                },
                            }}
                        />
                    </div>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
                        USA Map
                    </p>
                    <div className='sm:h-[300px] h-[150px]'>
                        <VectorMap
                            map={usMill}
                            backgroundColor='var(--bg-dark)'
                            regionStyle={{
                                initial: {
                                    fill: "var(--sky)"
                                },
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className='grid md:grid-cols-2 gap-30'>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
                        UK Map
                    </p>
                    <div className='sm:h-[300px] h-[150px]'>
                        <VectorMap
                            map={ukCountriesMill}
                            backgroundColor='var(--bg-dark)'
                            regionStyle={{
                                initial: {
                                    fill: "var(--warning)"
                                },
                            }}
                        />
                    </div>
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                    <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
                        Australia Map
                    </p>
                    <div className='sm:h-[300px] h-[150px]'>
                        <VectorMap map={auMill}
                            backgroundColor='var(--bg-dark)'
                            regionStyle={{
                                initial: {
                                    fill: "var(--success)"
                                },
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
